import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NotificationDialogComponent } from '@app/shared/dialog/notification-dialog/notification-dialog.component';
import { ReleaseNotesService } from '@app/shared/services/api/release-notes.service';
import { OverlayLoaderService } from '@app/shared/services/overlay-loader.service';
import { forEach } from 'lodash';
import { ReleaseNoteExtended } from '../../release-note-admin.component';

@Component({
  selector: 'app-release-notes-list',
  templateUrl: './release-notes-list.component.html',
  styleUrls: ['./release-notes-list.component.scss'],
})
export class ReleaseNotesListComponent {
  @Input() releaseNotes: ReleaseNoteExtended[] = [];
  @Output() addClicked = new EventEmitter<any>();
  @Output() editClicked = new EventEmitter<any>();

  constructor(private matDialog: MatDialog, private releaseNotesService: ReleaseNotesService, private overlayLoaderService: OverlayLoaderService) {}

  add() {
    forEach(this.releaseNotes, (item) => {
      item.isEditing = false;
    });
    this.addClicked.emit();
  }

  edit(data: ReleaseNoteExtended) {
    forEach(this.releaseNotes, (item) => {
      item.isEditing = false;
    });
    data.isEditing = true;
    this.editClicked.emit(data);
  }

  delete(data: ReleaseNoteExtended, index: number) {
    this.matDialog
      .open(NotificationDialogComponent, {
        data: {
          title: 'Neuerungen löschen',
          descriptionText: `Sind Sie sicher, dass Sie die Neuerungen löschen möchten?<br />Sobald sie gelöscht sind, ist eine Wiederherstellung nicht mehr möglich.`,
          confirmText: 'Ja',
          declineText: 'Nein',
        },
        panelClass: ['-md'],
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.editClicked.emit(null);
          this.overlayLoaderService.isLoading = true;
          this.releaseNotesService.delete(data.id).subscribe(() => {
            this.releaseNotes.splice(index, 1);
            this.overlayLoaderService.isLoading = false;
          });
        }
      });
  }

  trackByRelease(_: number, item: ReleaseNoteExtended) {
    return item.id;
  }

  trackByNotes(_: number, item: ReleaseNoteExtended) {
    return item;
  }
}
